<template>
  <main
    data-component="404-page"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
    v-background-color="$store.getters['ui/getBackgroundColor']"
  >
    <MainHeader :hideTableNumber="true"/>
    <h1
      data-element="title"
      v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
      v-color="this.$store.getters['ui/getPrimaryColor']"
      v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
      :style="{ fontSize: '76px' }"
    >
      404
    </h1>
    <p
      data-element="text"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
      :style="{ fontSize: '16px' }"
    >
      Sorry, we can't find that page
    </p>
    <btn
      text="Go to homepage"
      data-position="center"
      size="md"
      href="/"
      :fontStyle="{...this.$store.getters['ui/getBodyCopyFontDetail']('normal'), textSize:'18px'}"
      :backgroundColor="$store.getters['ui/getSecondaryColor']"
      :link="true"
    />
  </main>
</template>

<script>
  import Btn        from '@/components/ui/Btn';
  import MainHeader from '@/components/ui/MainHeader';

  export default {
    name: 'error-page',
    components: {
      Btn,
      MainHeader
    }
  };
</script>


<style lang="scss" scoped>

  [data-component='404-page'] {
    height:100vh;
    [data-element='title'] {
      padding-top:32px;
      height:64px;
    }
    [data-element='text'] {
      padding:40px 0 73px;
    }
  }
</style>
